export const MAIN_CLASS_NAME = 'schedule-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const ENABLE_CLASS_NAME = `${CONTENT_CLASS_NAME}__enable`;
export const MODE_CLASS_NAME = `${CONTENT_CLASS_NAME}__mode`;
export const DAILY_CLASS_NAME = `${CONTENT_CLASS_NAME}__daily`;
export const CUSTOM_CLASS_NAME = `${CONTENT_CLASS_NAME}__custom`;
export const WEEKDAY_CLASS_NAME = `${CUSTOM_CLASS_NAME}__weekday`;
export const WEEKDAY_ITEM_CLASS_NAME = `${WEEKDAY_CLASS_NAME}__item`;

export const DAYS_OF_WEEK_COUNT = 7;
export const DEFAULT_TIME = '00:00:00';
